module.exports = __webpack_public_path__ + "media/images/topics/JTRstar-36ffd45c69230df7af1adeb374ec7ec3.png";